/* SB · Bland selv »Mix 3« — the test version of the Bland selv builder (Elevate A/B vs sb-bland-selv.js).
   Same cart contract as the live page: every pack line carries the hidden attribute _bland_selv=1 and the
   "Casper's Bland selv" discount function prices those lines (3 → 30 %, 4 → 35 %, 5+ → 40 %).
   New here: one item can always be bought (normal price below 3), a rail that grows 3 → 4 → 5 as tiers unlock,
   and a reward pop-up the first time the customer's own tap reaches 3, 4 and 5 items. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bsv]');
  if (!root) return;

  function readJson(sel) {
    try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { console.error('[bsv] bad json', sel, e); return null; }
  }
  var PRODUCTS = readJson('[data-bsv-products]') || [];
  var FAMILIES = readJson('[data-bsv-families]') || [];
  var CFG = readJson('[data-bsv-config]') || { tiers: [[3, 30], [4, 35], [5, 40]], messages: {}, cats: [] };
  var M = CFG.messages || {};
  var TIERS = CFG.tiers; // [[minCount, pct], ...] ascending
  var MIN_COUNT = TIERS[0][0];
  var MAX_COUNT = TIERS[TIERS.length - 1][0];
  var VARIANT = CFG.variant || 'mix3';
  var STRIP = (CFG.stripPrefix || '').split(',').filter(Boolean);
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORE_KEY = 'bsv-mix3-rewards';

  var BY = {};
  PRODUCTS.forEach(function (p) { BY[p.id] = p; });
  if (CFG.hideSoldOut) {
    FAMILIES = FAMILIES.map(function (f) { var vs = f.variants.filter(function (v) { return BY[v.id] && BY[v.id].available; }); return Object.assign({}, f, { variants: vs, def: vs.some(function (v) { return v.id === f.def; }) ? f.def : (vs[0] && vs[0].id) }); });
  }
  FAMILIES = FAMILIES.filter(function (f) { return f.variants.length && f.variants.every(function (v) { return BY[v.id]; }); });
  /* Size chip label when the block left it blank: "Ø28", "32×26,5", else the name without the strip prefixes. */
  function shortLabel(name) {
    var m = /Ø\s?(\d+(?:,\d+)?)/.exec(name); if (m) return 'Ø' + m[1];
    m = /(\d+(?:,\d+)?)\s?[×x]\s?(\d+(?:,\d+)?)/.exec(name); if (m) return m[1] + '×' + m[2];
    return shortName(name);
  }
  FAMILIES = FAMILIES.map(function (f) { return Object.assign({}, f, { variants: f.variants.map(function (v) { return v.short ? v : Object.assign({}, v, { short: shortLabel(BY[v.id].name) }); }) }); });
  /* Bestseller label: editor-picked variant ids. */
  var BEST = {};
  (readJson('[data-bsv-popular]') || []).forEach(function (id) { if (BY[id]) BEST[id] = true; });

  /* ---------- helpers ---------- */
  function r2(n) { return Math.round(n * 100) / 100; }
  function fmt(n) {
    var v = r2(n), w = Math.floor(v), f = Math.round((v - w) * 100);
    var s = String(w).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (f ? s + ',' + String(f).padStart(2, '0') : s) + ' kr';
  }
  /* "30 %" never breaks between the number and the sign */
  function nb(s) { return String(s == null ? '' : s).replace(/ %/g, ' %'); }
  function fill(tpl, pct, amount) { return nb(String(tpl || '').replace('[pct]', pct).replace('[amount]', amount)); }
  function pctFor(c) { var p = 0; TIERS.forEach(function (t) { if (c >= t[0]) p = t[1]; }); return p; }
  /* reward step a count belongs to: 3, 4, or 5 for every count from 5 up; 0 below the first tier */
  function tierOf(c) { return c >= MAX_COUNT ? MAX_COUNT : c >= MIN_COUNT ? c : 0; }
  function nextMsg(c) {
    if (c >= 5) return M.m5; if (c === 4) return M.m4; if (c === 3) return M.m3; if (c === 2) return M.m2; if (c === 1) return M.m1; return M.m0;
  }
  function word(c) { return c === 1 ? M.one : M.many; }
  function shortName(name) { STRIP.forEach(function (s) { if (name.indexOf(s) === 0) name = name.slice(s.length); }); return name; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(r) { var n = Math.round((r || 0) * 2) / 2, out = ''; for (var i = 1; i <= 5; i++) out += i <= n ? '★' : (i - .5 === n ? '★' : '☆'); return out; }
  function count(q) { return Object.keys(q).reduce(function (n, id) { return n + q[id]; }, 0); }
  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function track(name, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name, bsv_variant: VARIANT }, data)); } catch (e) { /* analytics optional */ }
  }

  /* ---------- ticking numbers ---------- */
  var lastTick = {};
  var tickTimers = {};
  function tick(el, key, value) {
    if (!el) return;
    var from = lastTick[key];
    lastTick[key] = value;
    if (from == null || from === value || REDUCED) { el.textContent = fmt(value); el.classList.remove('is-hot'); return; }
    cancelAnimationFrame(tickTimers[key]);
    var t0 = performance.now(), d = 600;
    el.classList.add('is-hot');
    (function frame(now) {
      var k = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (value - from) * e);
      if (k < 1) tickTimers[key] = requestAnimationFrame(frame);
      else { el.textContent = fmt(value); el.classList.remove('is-hot'); }
    })(t0);
  }

  /* ---------- reward memory: which pop-ups this visitor has seen (per browser session) ---------- */
  function readRewards() {
    try { var v = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}'); return { unlock: Number(v.unlock) || 0, shown: Array.isArray(v.shown) ? v.shown : [] }; }
    catch (e) { return { unlock: 0, shown: [] }; }
  }
  function saveRewards() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ unlock: state.unlock, shown: state.shown })); } catch (e) { /* private mode: in-memory only */ }
  }

  /* ---------- state ---------- */
  var saved = readRewards();
  var state = { qty: {}, sel: {}, filter: 'alle', open: false, busy: false, unlock: saved.unlock, shown: saved.shown, reward: 0 };

  function selFor(qty, prev) {
    var sel = Object.assign({}, prev || {});
    FAMILIES.forEach(function (f) {
      var hit = f.variants.find(function (v) { return qty[v.id]; });
      sel[f.fid] = hit ? hit.id : (sel[f.fid] || f.def || f.variants[0].id);
    });
    return sel;
  }

  /* A tier reached by the customer's own tap opens its pop-up once; tiers already in the cart on load never do. */
  function applyQty(q, byTap) {
    var c = count(q), tier = tierOf(c);
    var prevCount = count(state.qty);
    state.qty = q;
    if (tier > state.unlock) state.unlock = tier;
    var reward = 0;
    if (byTap && c > prevCount && tier && state.shown.indexOf(tier) < 0) { reward = tier; state.shown = state.shown.concat([tier]); }
    saveRewards();
    renderAll();
    if (byTap) track('bsv_pack_change', { count: c, pct: pctFor(c) });
    if (reward) openReward(reward);
  }
  function change(id, d) {
    var q = Object.assign({}, state.qty); var n = (q[id] || 0) + d;
    if (n <= 0) delete q[id]; else q[id] = n;
    applyQty(q, true);
  }
  function remove(id) { var q = Object.assign({}, state.qty); delete q[id]; applyQty(q, true); }

  function summary(qty) {
    var ids = Object.keys(qty).map(Number); var c = count(qty); var pct = pctFor(c);
    var lines = ids.map(function (id) { var p = BY[id]; var unit = r2(p.price * (1 - pct / 100)); return { id: id, p: p, qty: qty[id], unit: unit }; });
    var normal = lines.reduce(function (n, l) { return n + l.p.price * l.qty; }, 0);
    var total = lines.reduce(function (n, l) { return n + l.unit * l.qty; }, 0);
    return { count: c, pct: pct, lines: lines, normal: normal, total: total, saving: r2(normal - total), ok: c >= MIN_COUNT };
  }

  /* ---------- rail: 3 → 4 → 5 stops, one more each time a tier unlocks ---------- */
  function railModel(c) {
    var n = state.unlock >= 4 ? 5 : state.unlock >= 3 ? 4 : 3;
    var stops = [];
    TIERS.forEach(function (t) { if (t[0] <= n) stops.push({ k: t[0], left: Math.round(t[0] / n * 100), label: nb(t[1] + ' %'), reached: c >= t[0] }); });
    return { stops: stops, fill: Math.min(c, n) / n * 100 };
  }
  function renderRails(c) {
    var m = railModel(c);
    var html = '<div class="bsv-rail__track no-empty"></div><div class="bsv-rail__fill no-empty" style="width:' + m.fill + '%"></div>' +
      m.stops.map(function (s) { return '<div class="bsv-stop' + (s.reached ? ' is-reached' : '') + '" style="left:' + s.left + '%"><span class="bsv-stop__dot">✓</span><span class="bsv-stop__label">' + esc(s.label) + '</span></div>'; }).join('');
    qsa('[data-bsv-railbox]').forEach(function (box) { box.innerHTML = html; });
    qsa('[data-bsv-rail]').forEach(function (el) { el.style.width = m.fill + '%'; });
  }

  /* ---------- rendering: chips + grid ---------- */
  function renderChips() {
    var box = qs('[data-bsv-chips]'); if (!box) return;
    var used = {}; FAMILIES.forEach(function (f) { used[f.cat] = true; });
    box.innerHTML = CFG.cats.filter(function (c) { return c[0] === 'alle' || used[c[0]]; }).map(function (c) {
      return '<button type="button" class="bsv-chip' + (state.filter === c[0] ? ' is-active' : '') + '" data-filter="' + c[0] + '" aria-pressed="' + (state.filter === c[0]) + '">' + esc(c[1]) + '</button>';
    }).join('');
  }
  function visibleFamilies() {
    var fams = FAMILIES.filter(function (f) { return state.filter === 'alle' || f.cat === state.filter; });
    /* Category order (as the filter chips), then block/collection order — so auto cards land in their group. */
    var catRank = {}; (CFG.cats || []).forEach(function (c, i) { catRank[c[0]] = i; });
    return fams.map(function (f, i) { return [f, i]; }).sort(function (a, b) { return ((catRank[a[0].cat] || 0) - (catRank[b[0].cat] || 0)) || (a[1] - b[1]); }).map(function (x) { return x[0]; });
  }
  function cardHtml(f, shownPct, ok) {
    var vid = state.sel[f.fid]; var p = BY[vid]; var q = state.qty[vid] || 0;
    var famQty = f.variants.reduce(function (n, v) { return n + (state.qty[v.id] || 0); }, 0);
    var name = shortName(p.name);
    var showSizeRow = f.variants.length > 1 || CFG.showSizes;
    var sizes = f.variants.length > 1
      ? f.variants.map(function (v) { return '<button type="button" class="bsv-size' + (v.id === vid ? ' is-selected' : '') + (state.qty[v.id] ? ' has-qty' : '') + '" data-size="' + v.id + '" data-fid="' + esc(f.fid) + '" aria-pressed="' + (v.id === vid) + '">' + esc(v.short) + '</button>'; }).join('')
      : '<div class="bsv-size--single">' + esc(f.single || f.variants[0].short || '') + '</div>';
    var reviews = p.reviews > 0
      ? '<span class="bsv-stars" aria-hidden="true">' + stars(p.rating) + '</span>' + (p.rating > 0 ? '<b>' + String(Math.round(p.rating * 10) / 10).replace('.', ',') + '</b> · ' : '') + p.reviews + ' <span class="bsv-card__revword">' + esc(M.reviews || '') + '</span>'
      : esc(M.newItem || '');
    var action = !p.available
      ? '<div class="bsv-stepper" style="border-color:var(--bsv-line)"><span class="bsv-stepper__qty" style="grid-column:1/-1;color:var(--bsv-ink-faint)">' + esc(M.soldOut) + '</span></div>'
      : q > 0
        ? '<div class="bsv-stepper"><button type="button" data-dec="' + vid + '" aria-label="Fjern én ' + esc(name) + '">−</button><span class="bsv-stepper__qty">' + q + '</span><button type="button" data-inc="' + vid + '" aria-label="Tilføj én ' + esc(name) + ' mere">+</button></div>'
        : '<button type="button" class="bsv-btn bsv-btn--primary bsv-card__add" data-inc="' + vid + '" aria-label="Tilføj ' + esc(name) + ' til pakken">' + esc(M.add) + '</button>';
    var isBest = BEST[vid] && M.best;
    var badges = (isBest ? '<span class="bsv-card__badge bsv-card__badge--best">' + esc(M.best) + '</span>' : '') +
      (famQty > 0 ? '<span class="bsv-card__badge">' + esc(M.inPack) + '</span>' : '');
    var note = nb(ok ? M.at + ' ' + shownPct + ' %' : M.before);
    return '<article class="bsv-card' + (famQty > 0 ? ' in-pack' : '') + (isBest ? ' is-best' : '') + (showSizeRow ? '' : ' bsv-card--nosize') + '" data-card="' + esc(f.fid) + '">' +
      '<div class="bsv-card__img"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy" width="300" height="300"></div>' +
      '<div class="bsv-card__badges no-empty">' + badges + '</div>' +
      (showSizeRow ? '<div class="bsv-card__sizes">' + sizes + '</div>' : '') +
      '<div class="bsv-card__name">' + esc(name) + '</div>' +
      '<div class="bsv-card__reviews no-empty">' + reviews + '</div>' +
      '<div class="bsv-card__price"><span class="bsv-tick" data-tick="c' + vid + '"></span><s>' + fmt(p.price) + '</s><span class="bsv-card__note bsv-card__note--inline">' + esc(note) + '</span></div>' +
      '<div class="bsv-card__note bsv-card__note-row">' + esc(note) + '</div>' +
      action + '</article>';
  }
  function renderGrid() {
    var box = qs('[data-bsv-grid]'); if (!box) return;
    var pct = pctFor(count(state.qty)); var shown = pct || TIERS[0][1];
    var fams = visibleFamilies();
    box.innerHTML = fams.map(function (f) { return cardHtml(f, shown, pct > 0); }).join('');
    fams.forEach(function (f) {
      var vid = state.sel[f.fid];
      tick(qs('[data-tick="c' + vid + '"]', box), 'c' + vid, r2(BY[vid].price * (1 - shown / 100)));
    });
  }

  /* ---------- rendering: builder panel + bar ---------- */
  function renderPanel(sm) {
    qs('[data-bsv-msg]').textContent = nb(nextMsg(sm.count));

    var lines = qs('[data-bsv-lines]');
    if (!sm.lines.length) lines.innerHTML = '<div class="bsv-empty">' + esc(M.empty) + '</div>';
    else lines.innerHTML = sm.lines.map(function (l) {
      var name = shortName(l.p.name);
      return '<div class="bsv-line"><div class="bsv-line__img"><img src="' + esc(l.p.img) + '" alt="" width="56" height="56"></div>' +
        '<div class="bsv-line__info"><div class="bsv-line__name" title="' + esc(l.p.name) + '">' + esc(name) + '</div><div class="bsv-line__price">' + (sm.pct > 0 ? '<s>' + fmt(l.p.price * l.qty) + '</s>' : '') + '<span class="bsv-tick" data-tick="ln' + l.id + '"></span></div>' +
        '<button type="button" class="bsv-line__remove" data-remove="' + l.id + '">' + esc(M.remove) + '</button></div>' +
        '<div class="bsv-stepper bsv-stepper--sm"><button type="button" data-dec="' + l.id + '" aria-label="Fjern én ' + esc(name) + '">−</button><span class="bsv-stepper__qty">' + l.qty + '</span><button type="button" data-inc="' + l.id + '" aria-label="Tilføj én ' + esc(name) + ' mere">+</button></div></div>';
    }).join('');
    sm.lines.forEach(function (l) { tick(qs('[data-tick="ln' + l.id + '"]', lines), 'ln' + l.id, l.unit * l.qty); });

    qs('.bsv-totals').hidden = sm.count === 0;
    qs('[data-bsv-normal]').textContent = fmt(sm.normal);
    qsa('[data-bsv-total]').forEach(function (el, i) { tick(el, 'total' + i, sm.total); });
    qs('[data-bsv-save-row]').hidden = sm.pct === 0;
    qs('[data-bsv-save]').textContent = nb(fmt(sm.saving) + ' (' + sm.pct + ' %)');

    /* A single item is always buyable: below 3 it goes in at normal price, only an empty pack is locked. */
    qsa('[data-bsv-addall]').forEach(function (btn) {
      var isBar = btn.classList.contains('bsv-bar__btn');
      btn.disabled = sm.count === 0 || state.busy;
      btn.textContent = state.busy ? M.adding
        : isBar ? M.addAllShort
        : sm.count === 0 ? M.ctaEmpty : sm.ok ? M.addAll : M.ctaNormal;
      btn.classList.toggle('is-loading', state.busy);
    });

    qs('[data-bsv-barlabel]').textContent = sm.count === 0 ? M.barEmpty : M.barPrefix + ' ' + sm.count + ' ' + word(sm.count);
    var sb = qs('[data-bsv-save-bar]'); sb.hidden = sm.pct === 0; sb.textContent = M.save + ' ' + fmt(sm.saving);
  }

  function renderAll() {
    var sm = summary(state.qty);
    renderRails(sm.count);
    renderGrid();
    renderPanel(sm);
    if (state.reward) renderReward();
  }

  /* ---------- body scroll lock shared by the sheet and the reward pop-up ---------- */
  function syncScrollLock() { document.body.style.overflow = state.open || state.reward ? 'hidden' : ''; }

  /* ---------- sheet (mobile) ---------- */
  var panel = qs('[data-bsv-panel]'), overlay = qs('[data-bsv-overlay]');
  function openSheet() {
    if (window.matchMedia('(min-width: 1024px)').matches) return;
    state.open = true; overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); panel.classList.add('is-open'); });
    panel.setAttribute('aria-modal', 'true'); syncScrollLock();
    var close = qs('[data-bsv-close]'); if (close) close.focus();
  }
  function closeSheet() {
    if (!state.open) return;
    state.open = false; overlay.classList.remove('is-open'); panel.classList.remove('is-open');
    panel.setAttribute('aria-modal', 'false'); syncScrollLock();
    setTimeout(function () { if (!state.open) overlay.hidden = true; }, 320);
  }

  /* ---------- reward pop-up ---------- */
  var rw = qs('[data-bsv-rw]');
  var rwA = qs('[data-bsv-rw-a]'), rwB = qs('[data-bsv-rw-b]');
  var rwReturnFocus = null;
  function renderReward() {
    var sm = summary(state.qty), tier = state.reward, isMax = tier >= MAX_COUNT;
    qs('[data-bsv-rw-title]').textContent = isMax ? nb(M.rwTitleMax) : fill(M.rwTitle, sm.pct, fmt(sm.saving));
    qs('[data-bsv-rw-amount]').textContent = fill(M.rwAmount, sm.pct, fmt(sm.saving));
    var msg = qs('[data-bsv-rw-msg]');
    msg.textContent = nb(isMax ? M.rwMax : tier === 3 ? M.rwNext4 : M.rwNext5);
    msg.classList.toggle('is-final', isMax);
    /* The cart button is always the red one. At 3 and 4 "show me more" comes first; at 5 the cart leads. */
    rwA.textContent = isMax ? M.rwKeep : M.rwMore;
    rwB.textContent = state.busy ? M.adding : M.addAll;
    rwB.disabled = state.busy;
    var actions = rwA.parentNode;
    if (isMax && actions.firstElementChild !== rwB) actions.insertBefore(rwB, rwA);
    if (!isMax && actions.firstElementChild !== rwA) actions.insertBefore(rwA, rwB);
  }
  function openReward(tier) {
    if (!rw) return;
    closeSheet();
    state.reward = tier;
    rwReturnFocus = document.activeElement;
    renderReward();
    rw.hidden = false; syncScrollLock();
    (tier >= MAX_COUNT ? rwB : rwA).focus();
    track('bsv_reward_view', { tier: tier, pct: pctFor(count(state.qty)) });
  }
  function closeReward() {
    if (!rw || !state.reward) return;
    state.reward = 0; rw.hidden = true; syncScrollLock();
    if (rwReturnFocus && document.contains(rwReturnFocus)) rwReturnFocus.focus();
    rwReturnFocus = null;
  }

  /* ---------- swipe down to close (mobile sheet + reward pop-up) ----------
     A drag starts on the handle/header, or anywhere once the sheet is scrolled to the top and the finger moves down.
     Far enough (or a quick flick) closes; otherwise the sheet springs back. Only transform moves. */
  var SWIPE_CLOSE_PX = 90, SWIPE_FLICK = 0.5, SWIPE_SLOP = 8;
  function swipeToClose(sheet, opts) {
    if (!sheet || !('ontouchstart' in window)) return;
    var drag = null;
    function scrolledInside(target) {
      for (var el = target; el && el !== sheet.parentNode; el = el.parentNode) { if (el.scrollTop > 0) return true; }
      return false;
    }
    function reset() { sheet.style.transition = ''; sheet.style.transform = ''; }
    sheet.addEventListener('touchstart', function (e) {
      if (!opts.isOpen() || e.touches.length !== 1 || window.matchMedia('(min-width: 1024px)').matches) return;
      var grip = !!e.target.closest(opts.grip);
      drag = { y0: e.touches[0].clientY, x0: e.touches[0].clientX, t0: Date.now(), dy: 0, on: false, grip: grip, free: grip || !scrolledInside(e.target) };
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (!drag || !drag.free) return;
      var dy = e.touches[0].clientY - drag.y0, dx = e.touches[0].clientX - drag.x0;
      if (!drag.on) {
        if (Math.abs(dy) < SWIPE_SLOP || Math.abs(dx) > Math.abs(dy) || dy < 0) { if (Math.abs(dy) >= SWIPE_SLOP && !drag.grip) drag = null; return; }
        drag.on = true; opts.begin(); sheet.style.transition = 'none';
      }
      e.preventDefault();
      drag.dy = Math.max(0, dy);
      sheet.style.transform = 'translateY(' + drag.dy + 'px)';
    }, { passive: false });
    function end() {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.on) return;
      var speed = d.dy / Math.max(1, Date.now() - d.t0);
      sheet.style.transition = '';
      if (d.dy > SWIPE_CLOSE_PX || speed > SWIPE_FLICK) opts.close(reset);
      else { sheet.style.transform = ''; }
    }
    sheet.addEventListener('touchend', end);
    sheet.addEventListener('touchcancel', end);
  }
  /* sheet: the class transition carries it from the finger down off screen */
  swipeToClose(panel, {
    grip: '.bsv-panel__handle, .bsv-panel__head',
    isOpen: function () { return state.open; },
    begin: function () {},
    close: function (reset) { reset(); closeSheet(); track('bsv_sheet_swipe_close', {}); }
  });
  /* reward: the entrance animation is dropped while dragging (an animation would pin transform), then it slides out */
  var rwBox = rw && rw.querySelector('.rw');
  swipeToClose(rwBox, {
    grip: '.rw-handle, .rw-badge, .rw-title',
    isOpen: function () { return !!state.reward; },
    begin: function () { rwBox.style.animation = 'none'; },
    close: function (reset) {
      var tier = state.reward;
      rwBox.style.transition = 'transform .22s ease-in';
      rwBox.style.transform = 'translateY(100%)';
      setTimeout(function () { closeReward(); reset(); rwBox.style.animation = ''; }, 220);
      track('bsv_reward_close', { tier: tier, how: 'swipe' });
    }
  });

  /* ---------- cart ---------- */
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  var MARK = '_bland_selv';
  function isPackLine(it) { return BY[it.variant_id] && it.properties && it.properties[MARK] === '1'; }
  function mirrorFromCart(cart) {
    var q = {};
    (cart.items || []).forEach(function (it) { if (isPackLine(it)) q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
    /* a pack that already sits in the cart counts as seen: no pop-up for tiers the customer reached earlier */
    var tier = tierOf(count(q));
    TIERS.forEach(function (t) { var k = tierOf(t[0]); if (k <= tier && state.shown.indexOf(k) < 0) state.shown = state.shown.concat([k]); });
    state.sel = selFor(q, state.sel);
    Object.keys(q).forEach(function (id) { lastTick['ln' + id] = null; });
    applyQty(q, false);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function addAll(source) {
    var sm = summary(state.qty); if (sm.count === 0 || state.busy) return;
    state.busy = true; renderPanel(sm); if (state.reward) renderReward();
    fetchCart().then(function (cart) {
      var lines = {}; (cart.items || []).forEach(function (it) { if (isPackLine(it)) lines[it.variant_id] = it; });
      var adds = [], changes = [];
      Object.keys(state.qty).forEach(function (id) {
        var props = {}; props[MARK] = '1';
        if (!lines[id]) adds.push({ id: Number(id), quantity: state.qty[id], properties: props });
        else if (lines[id].quantity !== state.qty[id]) changes.push({ id: lines[id].key, quantity: state.qty[id] });
      });
      Object.keys(lines).forEach(function (id) { if (!state.qty[id]) changes.push({ id: lines[id].key, quantity: 0 }); });
      var chain = Promise.resolve();
      changes.forEach(function (c) { chain = chain.then(function () { return post('/cart/change.js', c); }); });
      if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
      return chain;
    }).then(function () {
      state.busy = false; closeReward(); closeSheet(); renderAll();
      track('bsv_add_all', { count: sm.count, pct: sm.pct, total: sm.total, source: source || 'panel' });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    }).catch(function (err) {
      console.error('[bsv] add to cart failed', err);
      state.busy = false; renderAll();
      showError();
    });
  }
  function showError() {
    var msg = qs('[data-bsv-msg]'); msg.textContent = M.error;
    setTimeout(function () { msg.textContent = nb(nextMsg(count(state.qty))); }, 3000);
    if (state.reward) { var rm = qs('[data-bsv-rw-msg]'); rm.textContent = M.error; setTimeout(renderReward, 3000); }
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-inc],[data-dec],[data-remove],[data-size],[data-filter],[data-bsv-open],[data-bsv-close],[data-bsv-addall],[data-bsv-overlay],[data-bsv-rw-close],[data-bsv-rw-a],[data-bsv-rw-b]');
    if (!t) return;
    if (t.hasAttribute('data-inc')) return change(Number(t.getAttribute('data-inc')), 1);
    if (t.hasAttribute('data-dec')) return change(Number(t.getAttribute('data-dec')), -1);
    if (t.hasAttribute('data-remove')) return remove(Number(t.getAttribute('data-remove')));
    if (t.hasAttribute('data-size')) { state.sel = Object.assign({}, state.sel); state.sel[t.getAttribute('data-fid')] = Number(t.getAttribute('data-size')); return renderGrid(); }
    if (t.hasAttribute('data-filter')) { state.filter = t.getAttribute('data-filter'); renderChips(); return renderGrid(); }
    if (t.hasAttribute('data-bsv-open')) return openSheet();
    if (t.hasAttribute('data-bsv-close') || t.hasAttribute('data-bsv-overlay')) return closeSheet();
    if (t.hasAttribute('data-bsv-addall')) return addAll(t.classList.contains('bsv-bar__btn') ? 'bar' : 'panel');
    if (t.hasAttribute('data-bsv-rw-close')) { track('bsv_reward_close', { tier: state.reward }); return closeReward(); }
    if (t.hasAttribute('data-bsv-rw-a')) { track('bsv_reward_more', { tier: state.reward }); return closeReward(); }
    if (t.hasAttribute('data-bsv-rw-b')) return addAll('reward');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (state.reward) return closeReward();
    if (state.open) closeSheet();
  });
  window.matchMedia('(min-width: 1024px)').addEventListener('change', function (mq) { if (mq.matches) closeSheet(); });

  // Keep the builder in sync when the theme's cart drawer changes quantities.
  var syncTimer = null;
  function scheduleSync() { if (state.busy) return; clearTimeout(syncTimer); syncTimer = setTimeout(function () { fetchCart().then(mirrorFromCart).catch(function () {}); }, 400); }
  document.addEventListener('cart:refresh', scheduleSync);
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
    try { FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleSync); } catch (e) { /* optional */ }
  }

  /* ---------- no floating widgets or pop-ups on this page (inline !important beats their own CSS) ---------- */
  (function () {
    if (!CFG.hideWidgets) return;
    var list = String(CFG.hideSelectors || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!list.length) return;
    var sel = list.join(',');
    function hide() { try { document.querySelectorAll(sel).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); }); } catch (e) { /* bad selector */ } }
    hide();
    if ('MutationObserver' in window) new MutationObserver(hide).observe(document.body, { childList: true, subtree: false });
    [800, 2000, 4000].forEach(function (ms) { setTimeout(hide, ms); });
    /* The gift pop-up locks the page (html overflow hidden) when it opens; it is hidden here, so give the scroll back. */
    var gift = document.getElementById('CasperGamifiedPopupRoot');
    if (gift && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (gift.getAttribute('data-open') === 'true') document.documentElement.style.overflow = '';
      }).observe(gift, { attributes: true, attributeFilter: ['data-open'] });
    }
  })();

  /* ---------- init ---------- */
  state.sel = selFor({});
  renderChips(); renderAll();
  fetchCart().then(mirrorFromCart).catch(function (e) { console.warn('[bsv] cart mirror failed', e); }).then(function () {
    /* Deep link from a product page: ?add=<variant id> puts that product in the pack as item 1 (once, then the param is dropped). */
    try {
      var params = new URLSearchParams(location.search); var addId = params.get('add');
      if (addId && BY[addId] && BY[addId].available && !state.qty[addId]) {
        FAMILIES.forEach(function (f) { if (f.variants.some(function (v) { return String(v.id) === String(addId); })) state.sel[f.fid] = Number(addId); });
        change(Number(addId), 1);   /* local pack state only – the cart is written on "Læg hele pakken i kurven" */
        var grid = qs('[data-bsv-grid]'); if (grid) setTimeout(function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
      }
      if (addId) { params.delete('add'); history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash); }
    } catch (e) { console.warn('[bsv] deep link failed', e); }
  });
})();
